import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';
import "../AddressFinder/AddressFinderTypes";
import AddressWizard from '../AddressWizard/AddressWizard';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import "../FinderBase/FinderBaseV2";
//import FilterPanel = require("../../moreCore/UI/FilterPanel/FilterPanel");
import "../../moreCore/UI/FilterPanel/FilterPanel";

class AdressFinderHomeLM extends compose(FinderBaseV2) {
    //templateString = template;


    tableFormatter(cell: StaticTable.StaticTableCell<any>) {

        cell.contentnode.innerHTML = cell.value;

        switch (cell.name) {
            case "note":
                if (cell.value == "" || cell.value == null) {
                    this.UiModder.domClass.add(cell.tableRow.node, "w3-hide");
                }
                return true;
                break;
            
            default:
                return false;
                break;
        }
    }
    private requestNewEntity() {
        topic.publish("AddressFinder/RequestNew");
    }

    _onClick_Row(data?) {
        topic.publish("AddressFinder/OpenEntity", data)
    }

    _onCloseDetailsDlg_Callback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof AddressWizard>>) {
        let hasChanged = form.isDirty();
        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["AddressWizard__dataNotSaved"], "Speichern?", "", "", "yesno", lang.hitch(this, this._confirmCallback, dlg, form));

        } else {
            dlg.close();
        }
    }

    _confirmCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof AddressWizard>>, result) {
        if (result == -1) {
            dlg.close();
        } else {
            form.submitFormData();
            form.on("saveComplete", lang.hitch(dlg, dlg.close))
        }
       
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.setupFinder(
            "AddressFinder/GetFinderConfigurationLM",
            "AddressFinder/GetAddressListLM",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.tableFormatter),
            {
                neededUserRole: "Addresses_Create",
                callback: lang.hitch(this, this.requestNewEntity)
            }
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles(this.translations["General_LastModified"]);
        
    }
}

export default mdsWidget(AdressFinderHomeLM);